import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { LoadablePaint } from '@confluence/loadable';
import { CONTAINER_ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

const SpaceLookAndFeelSettingsRouteComponent = LoadablePaint({
	loader: async () =>
		import(
			/* webpackChunkName: "loadable-SpaceLookAndFeelSettingsRouteComponent" */ './SpaceLookAndFeelSettingsRouteComponent.tsx'
		),
});

export const SpaceLookAndFeelSettingsRoute: {
	({ params: { spaceKey, tab } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({
		name,
		params: { spaceKey },
	}: {
		name: any;
		params: {
			spaceKey: any;
		};
	}): {
		Screen: {
			screenEvent: {
				name: string;
				id: any;
			};
			pageState: {
				routeName: any;
				spaceKey: any;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: any;
		};
	};
} = ({ params: { spaceKey, tab } }: RouteMatch): React.JSX.Element => {
	return <SpaceLookAndFeelSettingsRouteComponent spaceKey={spaceKey} tab={tab} />;
};

SpaceLookAndFeelSettingsRoute.NAVIGATION_PARAMS = ({
	name,
	params: { spaceKey },
}: {
	name: any;
	params: {
		spaceKey: any;
	};
}): {
	Screen: {
		screenEvent: {
			name: string;
			id: any;
		};
		pageState: {
			routeName: any;
			spaceKey: any;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: any;
	};
} => ({
	Screen: {
		screenEvent: {
			name: 'spaceSettingLookAndFeelPage',
			id: spaceKey,
		},
		pageState: {
			routeName: name,
			spaceKey,
		},
	},
	MainLayout: {
		navView: CONTAINER_ADMIN_HOME_ID,
		spaceKey,
	},
});
